import React from "react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { getS3ProviderCopy } from "archive/logic/s3CompatibleProviders";
const AWSAuthenticationTypeFormGroup = ({
  updateAuthenticationType = () => {
  },
  currentType = "automatic",
  variant = "s3"
}) => {
  const { t } = useTranslation("enterprise_archive");
  const authTypeOptions = [
    { value: "automatic", label: t("aws_authentication_type_form_group.automatic") },
    { value: "keysecret", label: t("aws_authentication_type_form_group.key_secret") }
  ];
  return /* @__PURE__ */ React.createElement(Field, null, () => /* @__PURE__ */ React.createElement(Input, { id: "default-aws-auth-type-select", label: getS3ProviderCopy(variant).authTypeLabel }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "awsAuthenticationType",
      name: "AWSAuthenticationType",
      placeholder: t("aws_authentication_type_form_group.select_placeholder"),
      options: authTypeOptions,
      onChange: (option) => {
        updateAuthenticationType(option);
      },
      value: currentType
    }
  )));
};
export default AWSAuthenticationTypeFormGroup;
